// removed by extract-text-webpack-plugin
module.exports = {"hidden":"_2iJQS","visuallyhidden":"_-7RkI","hide-text":"_1G6hC","center":"_1sYQD","noprint":"_31_5t","articlesList":"_3AH9w","listItem":"_3SthN","article":"_36ACG","articleLink":"_3kCut"};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-article-list/styles/ArticleList.scss
 ** module id = 933
 ** module chunks = 1
 **/